<template>
  <vue-scroll>
  <div class="receipt-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="(tableToolsPanel.indexOf('filter')>-1? '隐藏':'展开')+'筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="业务编号" prop="orderNumber">
                  <Input v-model="filterModel.orderNumber" placeholder="输入保函编号" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="项目名称" prop="prjName">
                  <Input v-model="filterModel.prjName" placeholder="输入项目名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="受益人" prop="beneficiary">
                  <Input v-model="filterModel.beneficiary" placeholder="输入受益人名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="施工企业" prop="guaranteed">
                  <Input v-model="filterModel.guaranteed" placeholder="输入施工企业名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="经办机构" prop="guarantorName">
                  <Input v-model="filterModel.guarantorName" placeholder="输入经办机构名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary"
        to="/receipts/new"
        v-if="checkRolePermitted(['监管人','总监管人'])&&$store.getters.sysConfigs['ENABLE_RECEIPT']&&$store.getters.sysConfigs['ENABLE_SUPERVISOR_CREATE_RECEIPT']"
        icon="md-add">新增</Button>
      <Button type="primary"
        to="/receipts/new"
        v-if="checkRolePermitted(['保证人'])&&$store.getters.sysConfigs['ENABLE_RECEIPT']"
        icon="md-add">新增</Button>
    </div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
  </vue-scroll>
</template>

<script>
import moment from 'moment'
export default {
  name: 'receipt-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '业务编号',
          width: 160,
          key: 'orderNumber',
          resizable: true,
        },
        {
          title: '项目名称',
          key: 'prjName',
          resizable: true,
        },
        {
          title: '施工单位',
          key: 'guaranteed',
          resizable: true,
        },
        {
          title: '受益主体',
          key: 'beneficiary',
          resizable: true,
        },
        {
          title: '实缴金额',
          key: 'amount',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, params.row.amount ? Math.round(params.row.amount / 100 / 1000) / 10 + '万' : null)
          }
        },
        {
          title: '缴纳日期',
          key: 'gStartDate',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, params.row.gStartDate ? this.getMoment(params.row.gStartDate).format('YYYY-MM-DD') : null)
          }
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, params.row.createTime ? this.getMoment(params.row.createTime).format('YYYY-MM-DD') : null)
          }
        },
        {
          title: '状态',
          key: 'status',
          width: 120,
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: this.$common.guaranteeStatusColor[params.row.status]
              }
            }, this.$common.guaranteeStatus[params.row.status])
          }
        },
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                },
                style: {
                  // marginLeft: '5px'
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'receipt-detail', params: {orderNumber: params.row.orderNumber}})
                    }
                  }
                }, null),
              ]),
              (params.row.status === 7 || params.row.status === 6) && this.checkRolePermitted(['保证人']) && this.$store.getters.guarantorInfo && this.$store.getters.guarantorInfo.name === params.row.guarantorName
                ? h('Tooltip', {
                  props: {
                    content: '修改',
                    transfer: true
                  },
                  style: {
                    marginLeft: '5px'
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'warning',
                      ghost: true,
                      shape: 'circle',
                      icon: 'md-create'
                    },
                    on: {
                      click: () => {
                        // let userId = params.row.id
                        this.$router.push({path: '/receipts/new/' + params.row.orderNumber})
                      }
                    }
                  }, null),
                ]) : null,
              (params.row.status === 7 || params.row.status === 6) && this.checkRolePermitted(['保证人']) && this.$store.getters.guarantorInfo && this.$store.getters.guarantorInfo.name === params.row.guarantorName
                ? h('Tooltip', {
                  props: {
                    content: '删除',
                    transfer: true
                  },
                  style: {
                    marginLeft: '5px'
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      ghost: true,
                      shape: 'circle',
                      icon: 'md-trash'
                    },
                    on: {
                      click: () => {
                        // let userId = params.row.id
                        this.remove(params.row.orderNumber)
                      }
                    }
                  }, null),
                ]) : null,
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        orderNumber: null,
        guaranteed: null,
        guarantorName: null,
        beneficiary: null,
        prjName: null
      }
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  mounted () {
    this.initData()
    window.less.modifyVars({
      '@primaryColor': '#ff9900'
    })
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    getMoment (dt) {
      return moment(dt)
    },
    refresh () {
      // console.log('123')
      this.currentPageIndex = 1
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Receipt.listReceipts(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    async remove (orderNumber) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该记录么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Receipt.deleteReceipt(orderNumber).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.refresh()
        },
        onCancel: () => {
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.claim-list {
}
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
